import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'

export function DashboardReconnectChart({ setShowNavBar }) {
  const navigate = useNavigate()

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-8'>
            <button 
              onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}?isReconnect=1`) }} 
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-4'>
                  <p className='text-xl'>Reconnect Tax Transcripts</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <div>
              <p className='font-bold'>Based on our records, your IRS Authorization Form has been rejected for the following reason:</p>
              <p className='font-light italic'>{customerData.customerLeadData.leadContact.chartStatusDescription}</p>
              <p className='font-bold mt-4'>Please click the button above to reconnect your IRS Authorization Form.</p>
            </div>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>It appears there was an issue getting your transcripts. Click <span onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}?isReconnect=1`) }} className='text-[#FF8C00] underline cursor-pointer'>HERE</span> to reconnect you tax transcripts.</p>
      </div>
    </div>
  )
}